"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const react_device_detect_1 = require("react-device-detect");
const accountCardToDashboardBreakpoint = '@media (max-width:960px)';
const accountDrawerOverlapBreakpoint = '@media (max-width:960px)';
const styles = (theme) => ({
    root: {
        flexGrow: 1,
    },
    hide: {
        display: 'none',
    },
    componentWrapper: {
        margin: '0 auto',
        transform: 'translate3d(0, 0, 0)',
    },
    dropTarget: {
        borderLeft: `solid 3px ${theme.palette.slateGrey}`,
    },
    appFrame: {
        width: '100%',
        zIndex: 1,
        position: 'relative',
        display: 'flex',
        height: '100%',
    },
    content: Object.assign(Object.assign({ width: '100%', flexGrow: 1, textAlign: 'center', backgroundColor: 'unset', padding: theme.spacing(3) }, (!react_device_detect_1.isTablet && { overflow: 'auto' })), { transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }), paddingTop: 24, [theme.breakpoints.down('lg')]: {
            padding: theme.spacing(1),
        } }),
    cardSpace: {
        display: 'inline',
        [accountCardToDashboardBreakpoint]: {
            flexDirection: 'column',
            // transitions account side-bar into dashboard card
        },
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    configureDashboard: {
        color: theme.palette.text.primary,
        marginTop: 15,
    },
    syncNoticeWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        marginBottom: 16,
        marginRight: 8,
    },
    syncNotice: {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '6px 12px',
        borderRadius: 12,
        backgroundColor: 'transparent',
        fontSize: 12,
        lineHeight: '18px',
        color: theme.palette.text.primary,
        boxShadow: '0 0 0 1px transparent',
        transition: 'background-color 150ms ease, box-shadow 150ms ease',
    },
    syncNoticeHighlight: {
        backgroundColor: theme.palette.lemonChiffon,
    },
    syncNoticeText: {
        fontSize: 14,
        lineHeight: '18px',
        color: theme.palette.text.primary,
    },
    syncInfoButton: {
        padding: 4,
        marginLeft: 8,
    },
    syncInfoIcon: {
        fontSize: 18,
    },
    syncTooltip: {
        maxWidth: 280,
        padding: 0,
        fontSize: 12,
        lineHeight: '18px',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.white,
        boxShadow: '0px 6px 6px 0 rgba(0, 0, 0, 0.24)',
        borderRadius: 4,
    },
    syncTooltipTitle: {
        fontSize: 14,
        fontWeight: 600,
        lineHeight: '18px',
        color: theme.palette.text.primary,
        padding: 16,
        paddingBottom: 0,
    },
    syncTooltipCopy: {
        fontSize: 14,
        padding: 16,
        lineHeight: '18px',
        color: theme.palette.text.primary,
    },
    accountDrawerCard: {
        height: '100%',
        maxHeight: 'calc(100vh - 72px)',
        '&.noHeader': {
            height: 'calc(100vh - 72px)',
            [accountCardToDashboardBreakpoint]: {
                maxHeight: 342,
            },
        },
    },
    drawerPaper: {
        backgroundColor: 'unset',
        width: '100%',
        maxHeight: 'calc(100% - 72px)',
        [accountDrawerOverlapBreakpoint]: {
            position: 'relative',
        },
        // @ts-expect-error: An object literal cannot have multiple properties with the same name.
        [accountCardToDashboardBreakpoint]: {
            maxHeight: 342,
        },
    },
    drawerHeader: {
        paddingTop: 10,
        paddingLeft: theme.components.accountDrawer.basePadding,
        backgroundColor: 'unset',
    },
    accountDrawerContent: {
        maxHeight: 'calc(100vh - 132px)',
        [accountCardToDashboardBreakpoint]: {
            maxHeight: 282,
        },
    },
    accountDrawerContainer: {
        padding: '0 12px',
        width: 330,
        flex: '0',
        minWidth: '330px',
        position: 'fixed',
        top: 24,
        margin: '12px 0',
        maxHeight: 'calc(100vh - 72px)',
        height: 'calc(100vh - 72px)',
        [accountCardToDashboardBreakpoint]: {
            marginBottom: 0,
            top: 0,
            marginTop: 0,
            padding: 12,
            position: 'relative',
            width: '100%',
            maxHeight: 368,
            height: 368,
        },
    },
    gridStyle: {
        margin: '0 auto',
        width: '100%',
        maxWidth: 1178,
        [accountCardToDashboardBreakpoint]: {
            width: '100%',
            maxWidth: 1178,
            margin: '0 auto',
        },
    },
});
exports.styles = styles;
